<template>
	<div class="charts" id="pie">

	</div>

</template>

<script>
	import {
		queryPersonnel
	} from "@/api/msg/msg";
	export default {
		name: "charts",
		props: {
			title: {
				type: String,
				default: () => (
					''
				)
			},
		},
		data() {
			return {
				pieData: [{
					value: 335,
					name: "正式"
				}, {
					value: 310,
					name: "试用期"
				}, {
					value: 234,
					name: "实习生"
				}, {
					value: 135,
					name: "待离职"
				}], //
				colorArr: ["#FFD7D2", "#77E5E8", "#D46ACF", "#AB87F2", "#0FEF9C", "#E44D73", "#9825FD", "#FD5400", "#FEE62A",
					"#118EFA", "#0FEF9C", "#E44D73", "#9825FD", "#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD",
					"#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD"
				],
				pieSize: ["45%", "70%"],
				pieValue: ["正式", "试用期", "实习生", "待离职"], //
			}
		},
		created() {
			queryPersonnel().then(res => {
				console.log(res)
				let datas = res.data.data;
				let pieValue = [];
				let pieData = [];
				datas.map(data => {
					pieValue.push(data.name);
					pieData.push({
						value: data.num,
						name: data.name
					});
				})
				this.pieData = pieData;
				this.pieValue = pieValue;
				this.$nextTick(() => {
					this.drawpie("pie", this.pieData, this.pieValue, this.colorArr, this.pieSize, '#333');
				});
			})

		},
		methods: {
			drawpie(dom, data, value, color, size, textColor) {
				let myChart = this.$echarts.init(document.getElementById(dom));
				const option = {
					color: color,
					tooltip: {
						trigger: "item",
						formatter: "{a} <br/>{b}: {c} ({d}%)"
					},
					legend: {
						orient: 'vertical',
						x: "left",
						y: "center",
						left: "30",
						itemGap: 20,
						data: value,
						itemWidth: 12,
						itemHeight: 14,
						textStyle: {
							color: textColor,
							fontSize: 14,
							height: 17,
							lineHeight: 17,
							rich: {
								a: {
									width: 60,
								},
								b: {
									width: 20,
									align: 'right'
								},
							},
						},

						formatter: function(name) {
							let index = 0;
							var datas = option.series[0].data;
							datas.forEach(function(v, i) {
								if (v.name == name) {
									index = i;
								}
							})
							return [`{a| ${name}}`, `{b| ${datas[index].value} }`].join('');
						}
					},
					series: [{
						name: "人事概况",
						type: "pie",
						radius: size,
						center: ['70%', '50%'],
						avoidLabelOverlap: false,
						label: {
							normal: {
								show: false,
								position: "center"
							},
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: data
					}]
				};
				myChart.setOption(option);
			}
		}
	};
</script>

<style scoped>
	.charts {
		background: #fff;
		width: 100%;
		height: 210px;
		box-shadow: 0px 2px 4px 0px rgba(187, 187, 187, 0.25);
		border-radius: 4px;
	}
</style>
